<template>
    <div
        class="c-checkbox-wrapper custom-control"
        :class="{ 'custom-switch': props.switch, 'custom-checkbox': !props.switch }"
    >
        <input :id="elementId" v-model="checked" type="checkbox" class="custom-control-input" :disabled="disabled" />
        <label class="custom-control-label" :for="elementId">
            {{ label }}
            <slot />
        </label>
    </div>
</template>

<script lang="ts" setup>
import { computed, onBeforeMount, ref } from 'vue';
import { v4 } from 'uuid';

const emit = defineEmits<{
    (event: 'input', value: boolean): void;
}>();

const props = withDefaults(
    defineProps<{
        value?: boolean;
        id?: string;
        label?: string;
        switch?: boolean;
        disabled?: boolean;
    }>(),
    { value: false }
);

const elementId = ref('');

onBeforeMount(() => {
    elementId.value = props.id || `checkbox-${v4()}`;
});

const checked = computed({
    get: () => props.value,
    set: (value: boolean) => emit('input', value)
});
</script>

<style scoped lang="scss">
.vue-need-bootstrap {
    .custom-control-input ~ .custom-control-label::before {
        background-color: #fefefe;
        border-color: #bfbfbf;
        border-radius: 0.15rem;
    }

    .custom-control-input[disabled] ~ .custom-control-label::before,
    .custom-control-input:disabled ~ .custom-control-label::before {
        background-color: #fefefe;
        border-color: #e6e6e6;
    }
}
</style>
